import * as React from 'react';
import { Item } from '../../../../../../components/Grid';
import HistoryRowControls from '../../../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../../../components/HistoryRowListing';
import { IHistoryContext } from '../../../../../../containers/FormContextHandler';
import { sortPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import { newButton } from '../../../../utils/functions';
import HistorySection from 'Components/HistorySection';

const FormattedClassification = ({
  classification,
  fm,
}: {
  classification?: string;
  fm: (id: string) => string;
}): React.JSX.Element => {
  if (typeof classification !== 'string') return <span>{'-'}</span>;

  return (
    <span>
      {classification}
      {' - '}
      {(classification.includes('a') || classification.includes('b')) &&
        fm(`diagnosis.mgravis.mgfa.opts.${classification.substring(0, classification.length - 1)}`)}{' '}
      {fm(`diagnosis.mgravis.mgfa.opts.${classification}`)}
    </span>
  );
};

const MGFAHistory = ({
  documents = [],
  startEdit,
  fm = (): string => '',
}: IHistoryContext<IMGFA>): React.JSX.Element => {
  const mgfaDocs: Array<IMGFA> = documents.toSorted((d1, d2) => sortPartialDate(d2.date, d1.date));
  return (
    <HistorySection
      headerText={fm('diagnosis.mgravis.mgfa.title')}
      newButton={startEdit ? newButton('mgfa', startEdit({}, 'mgfa'), 'general.new', undefined, true) : undefined}
      hasHistoryRows={false}
    >
      <HistoryRowListing
        documents={mgfaDocs}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={10}>{fm('diagnosis.mgravis.mgfa.classification')}</Item>
          </>
        }
        contentFormat={(d: IMGFA): React.JSX.Element => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {d.date && formatPartialDate(d.date)}
            </Item>
            <Item xs={7}>
              <FormattedClassification classification={d.classification} fm={fm} />
            </Item>
            <Item xs={3}>{startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : null}</Item>
          </>
        )}
      />
    </HistorySection>
  );
};

export default MGFAHistory;
